import { useState, useEffect } from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { baseurladdress } from '../baseurl';
import axios from 'axios';



export default function Editbranch() {
    const { branch_id } = useParams();
    const accessuserid = localStorage.getItem("id");
    const accesstoken = localStorage.getItem("token");
    const Swal = require('sweetalert2')

    console.log("branch_id" + branch_id);
    let navigate = useNavigate();

    const [hidden, sethidden] = useState(true);
    const [cntry_name, setcntry_name] = useState([]);
    const [state_name, setstate_name] = useState([]);
    const [district_name, setdistrict_name] = useState([]);
    const [Branchregionuser, setBranchregionuser] = useState("");



    const [Branchname, setBranchname] = useState("");
    const [Branchcode, setBranchcode] = useState("");
    const [Branchregion, setBranchregion] = useState("");
    const [Branchphone, setBranchphone] = useState("");
    const [Branchmobile, setBranchmobile] = useState("");
    const [Branchemail, setBranchemail] = useState("");
    const [Branchpassword, setBranchpassword] = useState("");
    const [Branchcin, setBranchcin] = useState("");
    const [Branchcoordinates, setBranchcoordinates] = useState("");
    const [nablchechk, setnablchechk] = useState("");
    const [Branchplace, setBranchplace] = useState("");
    const [Branchaddress, setBranchaddress] = useState("");
    const [Branchcountry, setBranchcountry] = useState("");
    const [Branchstate, setBranchstate] = useState("");
    const [Branchdistrict, setBranchdistrict] = useState("");
    const [Branchpincode, setBranchpincode] = useState("");
    const [BranchStatus, setBranchStatus] = useState("");


    useEffect(() => {

        var data = {
            branch_id: branch_id
        }
        axios
            .get(baseurladdress + `editbranch/` + branch_id, {
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
            }
            )
            .then((res) => {
                const data = res.data.response;
                console.log("editbranch" + data)
                setBranchname(data[0].branch_name);
                setBranchcode(data[0].branch_code);
                setBranchregionuser(data[0].branch_region);
                setBranchphone(data[0].branch_phones);
                setBranchmobile(data[0].branch_mobile);
                setBranchemail(data[0].branch_email);
                setBranchpassword(data[0].branch_password);
                setBranchcin(data[0].branch_cinnumber);
                setBranchcoordinates(data[0].branch_coordinate);
                setnablchechk(data[0].branch_nabl);
                setBranchplace(data[0].branch_place);
                setBranchaddress(data[0].branch_resultaddress);
                setBranchcountry(data[0].branch_country);
                setBranchstate(data[0].branch_state);
                setBranchdistrict(data[0].branch_district);
                setBranchpincode(data[0].branch_pin);
                setBranchStatus(data[0].branch_status);
                getbranchregion();
                getcountry();
                getstate(data[0].branch_country);
                getdistrict(data[0].branch_state);
            });



    }, [branch_id]);



    //SUBMIT BRANCH 👇

    const handleSubmit = (event) => {

        event.preventDefault();
        const data = {

            branch_name: Branchname,
            branch_code: Branchcode,
            branch_region: Branchregionuser,
            branch_phones: Branchphone,
            branch_mobile: Branchmobile,
            branch_email: Branchemail,
            branch_password: Branchpassword,
            branch_cinnumber: Branchcin,
            branch_coordinate: Branchcoordinates,
            branch_nabl: nablchechk,
            branch_place: Branchplace,
            branch_resultaddress: Branchaddress,
            branch_country: Branchcountry,
            branch_state: Branchstate,
            branch_district: Branchdistrict,
            branch_pin: Branchpincode,
            branch_status: BranchStatus,
            branch_updby: accessuserid,
            branch_id: branch_id
        };


        fetch(
            baseurladdress + `updatebranch`,
            {
                method: "POST",

                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
            }
        )
            .then((res) => res.json())
            .then((result) => {
                if (result["status"] === "updated") {

                    //alert("Branch added successfully");
                    // window.location.href = "/branchlist";
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'success',
                        title: 'Branch Updated successfully'
                    })

                    navigate("/branchlist");

                }
                else {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'error',
                        title: 'Error'
                    })


                }

            });
    };





    // get branch region for edit 👇

    const getbranchregion = () => {
        axios.get(baseurladdress + `getallregions`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                //  console.log(data);
                const user = data.map((item, index) => {
                    var selectedd = (item.region_id == Branchregionuser
                    ) ? ' selected' : '';

                    return (
                        <option value={item.region_id} selected={selectedd}> {item.region_name} </option>
                    )
                }
                );
                setBranchregion(user);
            }).catch(error => {
                alert(error);
            })
    }


    //CHECK BRANCHNAME IF ALREADY EXISTS 👇


    const CheckBranchName = () => {
        const data = {
            branchname: Branchname,
        };
        fetch(
            baseurladdress + `checkexistbranchname`,
            {
                method: "POST",

                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
            }
        )
            .then((res) => res.json())
            .then((result) => {
                if (result["status"] === "exist") {

                    //alert("Branch added successfully");
                    // window.location.href = "/branchlist";
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'error',
                        title: 'Branch Name Already Exists Please Change'
                    })
                }
            });
    };


    const getdistrict = (district_state) => {

        axios.get(baseurladdress + `getdistricts/` + district_state, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                console.log(data);
                setdistrict_name(data);
            }).catch(error => {
                alert(error);
            })
    }

    const changeDistricts = (staffdistrict) => {
        axios.get(baseurladdress + `getdistricts/` + staffdistrict, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                setdistrict_name(data);
                console.log(district_name);
            }).catch(error => {
                alert(error);
            })
    }
    //CHECK BRANCHCODE IF ALREADY EXISTS 👇


    const CheckBranchCode = () => {

        const data = {
            branch_code: Branchcode,
        };
        fetch(
            baseurladdress + `checkexistbranchcode`,
            {
                method: "POST",

                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
            }
        )
            .then((res) => res.json())
            .then((result) => {
                if (result["status"] === "exist") {

                    //alert("Branch added successfully");
                    // window.location.href = "/branchlist";
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'error',
                        title: 'Branch Code Already Exists Please Change'
                    })
                }
            });
    };

    //TOOGLE PASSWORD 👇

    const hideandshow = () => {
        var x = document.getElementById("user_pass");
        if (x.type === "password") {
            x.type = "text";
            sethidden(false);
        } else {
            x.type = "password";
            sethidden(true);
        }
    }

    // GET ALL COUNTRY

    const getcountry = () => {

        axios.get(baseurladdress + `getallcountries`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                console.log(data);


                setcntry_name(data);


            }).catch(error => {
                alert(error);
            })
    }

    const changeTitle = (branchcntry) => {
        axios.get(baseurladdress + `getstates/` + branchcntry, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                console.log("statesss" + data);
                setstate_name(data);
            }).catch(error => {
                alert(error);
            })
    }


    const getstate = (state) => {

        axios.get(baseurladdress + `getstates/` + state, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                console.log(data);
                setstate_name(data);
            }).catch(error => {
                alert(error);
            })
    }


    return (
        <>
            <Sidennav />
            <Topnavbar />
            <div class="content-wrap">
                <div className="container-fluid">

                    <div className="col-md-2 ">
                        <NavLink activeClassName="active-link" to={"/branchlist"}>
                            <div style={{ display: "flex" }}>
                                <a class="float ">
                                    <i class="fa fa-arrow-left my-float" style={{ "marginTop": "21px" }}></i>
                                </a>
                            </div>
                        </NavLink>

                    </div>

                    <form
                        onSubmit={handleSubmit}
                    >
                        <div className='row'>
                            <div className='row'>

                                <div class="col-xl-6 col-xxl-12" >
                                    <div class="card">
                                        <div class="card-header">
                                            <h4 class="card-title">EDIT BRANCH </h4>
                                        </div>

                                        <div class="card-body">
                                            <div class="basic-form" >

                                                <div class="form-row">

                                                    <div class="col-sm-12">
                                                        <h6>Branch name </h6>
                                                        <input type="text" class="form-control"
                                                            value={Branchname}
                                                            onChange={(e) => setBranchname(e.target.value)}
                                                            required />
                                                    </div>
                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6> Code </h6>
                                                        <input type="text" class="form-control"
                                                            value={Branchcode}
                                                            onChange={(e) => setBranchcode(e.target.value)}
                                                            //   onClick={() => CheckBranchName()}
                                                            required />
                                                    </div>


                                                    <div className="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>Password </h6>
                                                        <div className="input-group mb-3">
                                                            <input

                                                                className="form-control "
                                                                name="userpass"
                                                                id="user_pass" type="password"
                                                                value={Branchpassword}
                                                                onChange={(e) => setBranchpassword(e.target.value)}
                                                                //  onClick={() => CheckBranchCode()}
                                                                required
                                                            />
                                                            <div className="input-group-append">
                                                                <div className="input-group-text"
                                                                    onClick={() => {
                                                                        hideandshow();

                                                                    }}
                                                                >
                                                                    <span
                                                                        class="fa fa-eye text-info"
                                                                        style={{ cursor: "pointer" }}
                                                                        id="togglePassword"

                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>Phone </h6>
                                                        <input class="form-control"
                                                            value={Branchphone}
                                                            onChange={(e) => setBranchphone(e.target.value)}
                                                            pattern="[0-9]+" maxLength="14" />
                                                    </div>
                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>Mobile </h6>
                                                        <input class="form-control"
                                                            value={Branchmobile}
                                                            onChange={(e) => setBranchmobile(e.target.value)}
                                                            pattern="[0-9]+" maxLength="14" />
                                                    </div>


                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>Email </h6>
                                                        <input type="email" class="form-control"
                                                            value={Branchemail}
                                                            onChange={(e) => setBranchemail(e.target.value)}
                                                        />
                                                    </div>

                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>Region </h6>
                                                        <select
                                                            className="form-control select"
                                                            name="Region"
                                                            id="employee"
                                                            placeholder="Enter Role"
                                                            value={Branchregionuser}
                                                            onChange={(e) => setBranchregionuser(e.target.value)}
                                                        >
                                                            {Branchregion}
                                                        </select>

                                                    </div>




                                                    <div class="col-sm-6 mt-2 mt-sm-0" >
                                                        <h6>CIN Number </h6>
                                                        <input type="text" class="form-control"
                                                            value={Branchcin}
                                                            onChange={(e) => setBranchcin(e.target.value)}
                                                        />
                                                    </div>
                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>Co-ordinates </h6>
                                                        <input type="text" class="form-control"
                                                            value={Branchcoordinates}
                                                            onChange={(e) => setBranchcoordinates(e.target.value)}
                                                        />
                                                    </div>
                                                    <br></br>
                                                    {/* <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <input type="checkbox" name="nabl" className="selectsingle checku" value={1}
                                                            //  onClick={handlenabl}

                                                            style={{ cursor: "pointer" }}
                                                        />
                                                        <label className="form__label textal offset-1" for="clienttype">
                                                            NABL ?
                                                        </label>
                                                    </div> */}



                                                    <div class="col-sm-6 mt-2 mt-sm-0" >
                                                        <div className="">
                                                            <h6 className="form__label textal " for="clienttype">
                                                                NABL ?
                                                            </h6></div>


                                                        <div className="row" >
                                                            <div className="ddc" >


                                                                {nablchechk == "1" ? (
                                                                    <div className="form-check col-md-4">

                                                                        <input type="radio" checked class="form-check-input" name="nabl" value={1} onChange={(e) => setnablchechk(e.target.value)} />
                                                                        <span class="badge bg-success" >
                                                                            Yes
                                                                        </span>
                                                                    </div>
                                                                )
                                                                    : (
                                                                        <div className="form-check col-md-7">

                                                                            <input type="radio" class="form-check-input" name="nabl" value={1} onChange={(e) => setnablchechk(e.target.value)} />
                                                                            <span class="badge bg-success" >
                                                                                Yes
                                                                            </span>
                                                                        </div>

                                                                    )}


                                                            </div>


                                                            <div className="my" >


                                                                {nablchechk == "0" ? (
                                                                    <div className="form-check col-md-4">

                                                                        <input type="radio" checked class="form-check-input " name="nabl" value="0" onChange={(e) => setnablchechk(e.target.value)} />
                                                                        <span class="badge bg-danger" >
                                                                            No
                                                                        </span>
                                                                    </div>
                                                                )
                                                                    : (
                                                                        <div className="form-check col-md-7">

                                                                            <input type="radio" class="form-check-input " name="nabl" value="0" onChange={(e) => setnablchechk(e.target.value)} />
                                                                            <span class="badge bg-danger" >
                                                                                No
                                                                            </span>
                                                                        </div>

                                                                    )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-xxl-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="basic-form">
                                                <div class="form-row">
                                                    <div class="form-group col-md-12">
                                                        <h6>Place </h6>
                                                        <textarea class="form-control text alternativeaddress"
                                                            value={Branchplace}
                                                            onChange={(e) => setBranchplace(e.target.value)}
                                                        />
                                                    </div>
                                                    <div class="form-group col-md-12">
                                                        <h6>Alternate Address </h6>
                                                        <textarea class="form-control text alternativeaddress"
                                                            value={Branchaddress}
                                                            onChange={(e) => setBranchaddress(e.target.value)}
                                                        />
                                                    </div>
                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>Country </h6>
                                                        <select
                                                            className="form-control select"
                                                            name="Country"
                                                            onChange={e => {
                                                                changeTitle(e.target.value);
                                                                setBranchcountry(e.target.value)
                                                            }}

                                                        >
                                                            <option value="" disabled selected>
                                                                Select
                                                            </option>
                                                            {cntry_name.map((obj) => {
                                                                var selected = (Branchcountry == obj.cntry_id) ? "selected" : "";
                                                                return (
                                                                    <option value={obj.cntry_id} selected={selected} >{obj.cntry_name}</option>
                                                                )
                                                            }

                                                            )}

                                                        </select>
                                                    </div>
                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>State </h6>
                                                        <select
                                                            className="form-control select"
                                                            name="State"
                                                            onChange={e => {
                                                                changeDistricts(e.target.value);
                                                                setBranchstate(e.target.value)
                                                            }}
                                                        >
                                                            <option value="" disabled selected>
                                                                Select
                                                            </option>

                                                            {state_name.map((obj) => {

                                                                var selected = (Branchstate == obj.state_id) ? "selected" : "";

                                                                return (
                                                                    <option value={obj.state_id} selected={selected} >{obj.state_name}</option>
                                                                )
                                                            }

                                                            )}
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>District </h6>
                                                        <select
                                                            className="form-control select"
                                                            name="District"
                                                            onChange={(e) => setBranchdistrict(e.target.value)}
                                                        >
                                                            <option value="" disabled selected>
                                                                Select
                                                            </option>
                                                            {/* {district_name} */}
                                                            {district_name.map((obj) => {

                                                                var selected = (Branchdistrict == obj.district_id) ? "selected" : "";

                                                                return (
                                                                    <option value={obj.district_id} selected={selected} >{obj.district_name}</option>


                                                                )

                                                            }

                                                            )}
                                                        </select>
                                                    </div>

                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6>Pin </h6>
                                                        <input type="text" class="form-control"
                                                            value={Branchpincode}
                                                            onChange={(e) => setBranchpincode(e.target.value)}
                                                            maxLength="6" />
                                                    </div>

                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <div className="">    <h6 className="form__label textal " >
                                                            Status
                                                        </h6></div>


                                                        <div className="row" >
                                                            <div className="hr">


                                                                {BranchStatus == "1" ? (
                                                                    <div className="form-check col-md-4">

                                                                        <input type="radio" checked class="form-check-input" name="status" value={1} onChange={(e) => setBranchStatus(e.target.value)} />
                                                                        <span class="badge bg-success" >
                                                                            Active
                                                                        </span>
                                                                    </div>
                                                                )
                                                                    : (
                                                                        <div className="form-check col-md-7">

                                                                            <input type="radio" class="form-check-input" name="status" value={1} onChange={(e) => setBranchStatus(e.target.value)} />
                                                                            <span class="badge bg-success" >
                                                                                Active
                                                                            </span>
                                                                        </div>

                                                                    )}


                                                            </div>


                                                            <div className="hr" >


                                                                {BranchStatus == "0" ? (
                                                                    <div className="form-check col-md-4">

                                                                        <input type="radio" checked class="form-check-input " name="status" value="0" onChange={(e) => setBranchStatus(e.target.value)} />
                                                                        <span class="badge bg-danger" >
                                                                            Inactive
                                                                        </span>
                                                                    </div>
                                                                )
                                                                    : (
                                                                        <div className="form-check col-md-7">

                                                                            <input type="radio" class="form-check-input " name="status" value="0" onChange={(e) => setBranchStatus(e.target.value)} />
                                                                            <span class="badge bg-danger" >
                                                                                Inactive
                                                                            </span>
                                                                        </div>

                                                                    )}
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-12 offset-5" style={{ "marginTop": "35px" }}>
                                                        <button type="submit" class="btn btn-primary mb-2"  >UPDATE</button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>

                                </div >


                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>

    )
}
